export const locale = {
  lang: 'en',
  data: {
    MENU: {
      HOME: 'Home',
      SAMPLE: 'Sample',
      INFRA_OPS: 'Infrastructure Admin'
    }
  }
}
